import { gql, useLazyQuery, useQuery } from '@apollo/client'

export const LIST_TAGS = gql`
  query ListTags {
    tags {
      id
      tag
      tagType
      description
      startDate
      endDate
      active
      include
      exclude
      createdAt
      lastEvaluatedAt
    }
  }
`

export const GET_PATIENTS_BY_TAG = gql`
  query GetPatientsByTag($tagId: ID!, $cursor: DateTimeIDCursor, $limit: Int) {
    patientListByTag(tagId: $tagId, cursor: $cursor, limit: $limit) {
      patients {
        id
        codeName
      }
      pageInfo {
        endCursor
      }
    }
  }
`

export const GET_TAG_STATS = gql`
  query GetTagStats($tagId: ID!) {
    tagStats(tagId: $tagId) {
      patientCount
      lastEvaluatedAt
    }
  }
`

export const useTagList = (options = {}) => {
  return useQuery(LIST_TAGS, {
    fetchPolicy: 'cache-and-network',
    ...options,
  })
}

export const useTagStats = (tagId, options = {}) => {
  return useQuery(GET_TAG_STATS, {
    variables: { tagId },
    fetchPolicy: 'cache-and-network',
    skip: !tagId,
    ...options,
  })
}

export const useTagStatsLazy = (options = {}) => {
  return useLazyQuery(GET_TAG_STATS, {
    fetchPolicy: 'network-only',
    ...options,
  })
}
